import { RFISCANNER_CONTEXT } from '@/constants/context';
import { VIDEO_URLS } from '@/constants/videos';
import React from 'react';

const RFIScanner = () => {
  return (
    <>
      <div
        id='content-RFIScanner'
        className='w-full h-full flex flex-col box-border xl:gap-6 relative overflow-hidden rounded-lg'
      >
        <div className='relative z-20 flex flex-col gap-6 xl:w-[600px] xl:h-[400px] md:h-[350px] h-[642px]'>
          <div className='w-full flex flex-col justify-start px-4 md:px-0'>
            <h1 className='leading-7 md:leading-8 text-4xl md:text-4xl font-bold text-white text-left'>
              <strong>
                RFI <span className='text-[#fccb15]'>S</span>canner
              </strong>
            </h1>
          </div>
          <div className='border-l-4 border-[#FCCB16] md:pl-3 ml-4 md:ml-0'>
            <div className='text-base md:text-xl font-semibold text-white px-4 md:px-0'>
              {RFISCANNER_CONTEXT.SUBTITLE}
            </div>
          </div>
          <div className='w-full flex justify-start items-start px-4 md:px-0'>
            <section className='w-full flex justify-start'>
              <div className='text-sm md:text-lg font-medium text-white md:text-justify xl:hidden'>
                {RFISCANNER_CONTEXT.DESCRIPTION}
              </div>
              <div className='hidden xl:block text-lg font-medium text-white'>
                {RFISCANNER_CONTEXT.DESCRIPTION.split('time.').map(
                  (part, index) => (
                    <p key={index} className={index > 0 ? '' : ''}>
                      {index === 0 ? part + 'time.' : part.trim()}
                    </p>
                  )
                )}
              </div>
            </section>
          </div>
          <div className='md:hidden relative w-[691px] h-[319px] overflow-hidden rounded-lg -mx-4'>
            <video
              className='absolute w-full h-full object-cover pointer-events-none left-[-130px] bottom-[20%]'
              muted
              autoPlay
              loop
              controls={false}
              disablePictureInPicture
              playsInline
              onContextMenu={e => e.preventDefault()}
            >
              <source src={VIDEO_URLS.RFI_SCANNER} />
            </video>
          </div>
        </div>

        {/* Mobile & Tablet Video */}
        <div className='xl:hidden hidden md:block relative w-full h-[250px] md:h-[447px] overflow-hidden rounded-lg'>
          <video
            className='absolute w-full h-full object-cover pointer-events-none md:scale-125 left-[3%] bottom-[30%]'
            muted
            autoPlay
            loop
            controls={false}
            disablePictureInPicture
            playsInline
            onContextMenu={e => e.preventDefault()}
          >
            <source src={VIDEO_URLS.RFI_SCANNER} />
          </video>
        </div>
      </div>
      {/* Desktop Video */}
      <video
        className='hidden xl:block absolute bottom-[20%] left-[35%] w-[786px] h-[442px] object-cover pointer-events-none z-[-100]'
        playsInline
        muted
        autoPlay
        loop
        controls={false}
        disablePictureInPicture
        onContextMenu={e => e.preventDefault()}
      >
        <source src={VIDEO_URLS.RFI_SCANNER} />
      </video>
    </>
  );
};

export default React.memo(RFIScanner);
